import { render, staticRenderFns } from "./MobileWheelOfFortune.vue?vue&type=template&id=2060d37c&scoped=true&"
import script from "./MobileWheelOfFortune.vue?vue&type=script&lang=js&"
export * from "./MobileWheelOfFortune.vue?vue&type=script&lang=js&"
import style0 from "./MobileWheelOfFortune.vue?vue&type=style&index=0&id=2060d37c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2060d37c",
  null
  
)

export default component.exports